var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewRotate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 90,
    viewBox: "0 0 160 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    fill: "#c7c7c8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.34 17.21)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2,
    strokeDasharray: "5 1",
    opacity: 0.587
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.581,
    height: 55.581,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 53.581,
    height: 53.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.757 25.946) rotate(-16)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.581,
    height: 55.581,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 53.581,
    height: 53.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12014.131,8303.076s-10.181-2.059-16.11,3.588-3.809,15.05-3.809,15.05",
    transform: "translate(12061.296 -8292.189)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11827.312,8355.558l4.257,4.315,4.257-4.315",
    transform: "translate(11850.181 -8328.191)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 158.434, 78.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12014.131,8303.076s-10.181-2.059-16.11,3.588-3.809,15.05-3.809,15.05",
    transform: "translate(12061.296 -8292.189)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11827.312,8355.558l4.257,4.315,4.257-4.315",
    transform: "translate(11850.181 -8328.191)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewRotate);
export default __webpack_public_path__ + "static/media/preview_rotate.c9b53e6a1d8576218ed1d30b5910d74f.svg";
export { ForwardRef as ReactComponent };